module.exports = __webpack_public_path__ + "img/handraw.ee919b92.svg";